export default {
  title: {
    fontSize: '2.5rem',
  },
  cta: {
    display: 'flex',
    margin: '3rem 0 0',
  },
}
